/*
 * @FileName       : Inventory.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : All the models for inventory reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

export class TenantsFilter {
	offset?: number;
	limit?: number;
	skip?: number;
	order?: any[];
	where?: {};
	fields?: {};
}

export interface TenantsList {
	id: number;
	customerId: string;
	name: string;
}

export class CustomerListFilter {
	customerId?: object | string;
	status?: string;
	state?: string;
	zip?: object | string;
	createdAt?: object | string;
	primaryContact?: boolean;
	manualSplitBill?: string;
	autoSplitBill?: string;
	classOfTradeDescription?: string;
	facilityTypeDescription?: string;
}
